import { createUseStyles } from 'react-jss';
import { Theme } from '@mui/material';

export const useStyles = createUseStyles((theme: Theme) => {
    const { color, radius, mq, font } = theme.custom;
    return {
        grid: {
            display: 'grid',
            gridTemplateColumns: 'minmax(0, 1fr) 320px',
            gap: 20,
            alignItems: 'start',
            [mq.md]: { gridTemplateColumns: 'minmax(0, 1fr) 280px' },
            [mq.sm]: { gridTemplateColumns: 'minmax(0, 1fr)', gap: 16 },
        },
        main: { display: 'flex', flexDirection: 'column', gap: 20, minWidth: 0, [mq.sm]: { gap: 16 } },
        side: { display: 'flex', flexDirection: 'column', gap: 20, minWidth: 0, [mq.sm]: { gap: 16, order: -1 } },
        scroll: { overflowX: 'auto', WebkitOverflowScrolling: 'touch' },
        numeric: { textAlign: 'right', fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' },
        mono: { fontFamily: font.mono, fontSize: 13, whiteSpace: 'nowrap' },
        secondary: { fontSize: 12, color: color.text.secondary, marginTop: 2 },
        thumbs: { display: 'flex', gap: 8, alignItems: 'center' },
        thumb: {
            display: 'block',
            width: 56,
            height: 56,
            borderRadius: radius.sm,
            objectFit: 'contain',
            backgroundColor: color.surfaceMuted,
            outline: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'}`,
            outlineOffset: -1,
        },
        thumbLink: {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: 56,
            height: 56,
            padding: '0 8px',
            borderRadius: radius.sm,
            border: `1px dashed ${color.borderStrong}`,
            fontSize: 12,
            fontWeight: 500,
            color: color.primary.main,
            textDecoration: 'none',
            '&:hover': { backgroundColor: color.primary.soft },
        },
        preview: { display: 'block', maxWidth: 360, maxHeight: 360, borderRadius: radius.sm },
        struck: {
            textDecoration: 'line-through',
            textDecorationColor: color.tone.danger.main,
            textDecorationThickness: 2,
            color: color.text.secondary,
        },
        actions: { display: 'flex', gap: 6, justifyContent: 'flex-end', flexWrap: 'wrap' },
        voided: { fontSize: 12, fontWeight: 600, color: color.text.secondary },
        // address block
        address: { margin: 0, fontStyle: 'normal', lineHeight: 1.6, fontSize: 14, '& b': { fontWeight: 600 } },
        summaryBody: { padding: '14px 16px 12px' },
        // totals (footer of the Summary panel)
        totals: { display: 'flex', flexDirection: 'column', gap: 6 },
        totalRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 12, fontSize: 14, color: color.text.secondary },
        totalValue: { fontVariantNumeric: 'tabular-nums', color: color.text.primary, fontWeight: 500 },
        grandTotal: {
            borderTop: `1px solid ${color.border}`,
            paddingTop: 8,
            color: color.text.primary,
            fontWeight: 600,
            '& $totalValue': { fontSize: 18, fontWeight: 600 },
        },
        // event timeline
        timeline: { listStyle: 'none', margin: 0, padding: '4px 20px 8px', [mq.sm]: { padding: '4px 16px 8px' } },
        event: {
            position: 'relative',
            display: 'grid',
            gridTemplateColumns: '150px minmax(0, 1fr)',
            gap: '2px 16px',
            padding: '12px 0 12px 22px',
            borderBottom: `1px solid ${color.border}`,
            '&:last-child': { borderBottom: 'none' },
            '&::before': {
                content: '""',
                position: 'absolute',
                left: 4,
                top: 19,
                width: 8,
                height: 8,
                borderRadius: '50%',
                backgroundColor: color.primary.main,
            },
            '&::after': {
                content: '""',
                position: 'absolute',
                left: 7.5,
                top: 30,
                bottom: -8,
                width: 1,
                backgroundColor: color.border,
            },
            '&:last-child::after': { display: 'none' },
            [mq.sm]: { gridTemplateColumns: 'minmax(0, 1fr)' },
        },
        eventTime: { fontSize: 13, color: color.text.secondary, fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' },
        eventAction: { fontWeight: 600, textTransform: 'capitalize' },
        eventDetails: { fontSize: 13, color: color.text.secondary, gridColumn: 2, [mq.sm]: { gridColumn: 1 } },
    };
});
